import api from '@/api/shortcut.js';

export default {
  state: {
    showModal: null,
    svgResponse: null,
  },
  getters: {
    showModal: state => state.showModal,
    getSvgResponse: (state) => state.svgResponse,
  },
  actions: {
    setModalToShow({ commit }, payload) {
      commit('SET_MODAL_TO_SHOW', payload);
    },
    clearModalToShow({ commit }) {
      commit('CLEAR_MODAL_TO_SHOW');
    },
    async getSVG({ commit }, svgUrl){
      try {
        const response = await api.fetchSvg(svgUrl);

        commit('SET_SVG_RESPONSE', response.data);

        return Promise.resolve(response.data);
      }
      catch (error) {
        return Promise.reject(error.response);
      }
    },
    setSVG({ commit }, svgUrl) {
      commit('SET_SVG_RESPONSE', svgUrl);
    },
  },
  mutations: {
    // Set on the format:
    // Object: { name: String, Object or null...  }
    SET_MODAL_TO_SHOW(state, payload) {
      state.showModal = payload;
    },
    CLEAR_MODAL_TO_SHOW(state) {
      state.showModal = null;
    },
    SET_SVG_RESPONSE(state, payload){
      state.svgResponse = payload;
    },
  }
};
